<template>
  <v-footer
    id="core-footer"
    absolute
    height="82"
  >
    <div class="footer-items">
      <span
        v-for="link in links"
        :key="link.name"
      >
        <router-link
          :to="link.Link"
          class="tertiary--text footer-links">{{ link.name }}</router-link>
      </span>
    </div>
    <v-spacer/>
    <span class="font-weight-light copyright">
      &copy;
      {{ (new Date()).getFullYear() }}
      <a
        href="http://bacbonltd.net/"
        target="_blank">BacBon Ltd</a>, all rights reserved
    
    </span>
  </v-footer>
</template>

<script>
export default {
  data: () => ({
    links: [
      { name: 'Home', Link: '/' },
      { name: 'LMS', Link: '/lms' },
      { name: 'Blog', Link: '#' }
    ]
  })
}
</script>

<style>
#core-footer {
  z-index: 0;
}
</style>
